module.exports = __webpack_public_path__ + "img/Weapon_96.dcf5a233.png";